
<template>
  <v-app id="searchGbrk">
    <v-main>
    <v-container fluid>  
    <v-card>
      <v-card-title>Invoice line items</v-card-title>
      <v-simple-table dense>
        <thead>
          <tr>
            <td>Number</td>
            <td>Description</td>
            <td>Balance / Profit-Loss</td>
            <td>Agent commission</td>
          </tr>  
        </thead>  
         <tbody v-for="(gbrkRecord,i) in searchGbrk" :key="i">
           <!-- <tr @click="$router.reload('/syst/ref/gbrk/onGbrk/' + gbrkRecord.gbrk_encrid)"> -->
           <tr>
             <td>{{gbrkRecord.gbrk_nr}}</td>
             <td>{{gbrkRecord.gbrk_oms}}</td>
             <td>{{gbrkRecord.gbrk_balvw}}</td>
             <td>{{gbrkRecord.gbrk_agtn_com}}</td>
           </tr>  
         </tbody>  
       </v-simple-table>  
    </v-card>  
    </v-container>
    </v-main>
    <navBar title="Ares - Reference data" :home="true" type="referencedata"/>    
  </v-app>
</template>


<script>
import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar
  },
  data() {
    return {
      searchGbrk: []
    }  
  },
  mounted() {
      this.$axios
        .post("ares/json/ares/syst/ref/gbrk/searchGbrk.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "searchGbrk"
          },
          searchGbrk: {
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.searchGbrk = res.data.searchGbrk;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
};

</script> 
